import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@src/store';

const ConfirmReducer = (state: RootState) => state.ConfirmReducer;
export const selectConfirm = createSelector([ConfirmReducer], (state) => state);
